import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import Icon from "@/components/icon";
interface FlashProps {
  type?: string;
  className?: string;
  children?: ReactNode;
}
export default function Flash(props) {
  const $ = _c(10);
  const type = props.type || "primary";
  const t0 = `w-full rounded flex items-center gap-3.5 text-white p-4 mb-6 h-fit ${props.className}`;
  const t1 = `bg-${type}`;
  const t2 = type === "primary" && "bg-opacity-25 text-primary ring-primary ring-1 ring-opacity-70";
  let t3;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2) {
    t3 = twMerge(t0, t1, t2);
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== type) {
    t4 = (type === "success2" || type === "success") && <div className="flex  rounded-full bg-white w-fit aspect-square"><Icon icon="check-simple" className="!fill-success2" /></div>;
    $[4] = type;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props.children || $[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t3}>{t4}{props.children}</div>;
    $[6] = props.children;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}